<div class="obg-m-multi-session-limit-header">
	<div>
		<h1>{{ 'multi-session-limit.title' | translate }}</h1>
		<p>{{ 'multi-session-limit.description' | translate }}</p>
	</div>
</div>

<div class="obg-m-multi-session-limit-queued-notification" *ngIf="upcomingSessionLimit">
	<span class="notification-icon ico-exclamation"></span>
	<label
		[innerHTML]="'multi-session-limit.upcoming-limit.' + (upcomingSessionLimit.limitPeriod | lowercase) | translate: {
				queuedLimit: upcomingSessionLimit.limitValue,
				activeFrom: upcomingSessionLimit.activeFrom | date: 'dd MMMM yyyy'
			}"
		test-id="upcoming-limit"
	>
	</label>
</div>

<mat-card class="obg-m-multi-session-limit-container">
	<div class="obg-m-multi-session-limit-current-amount">
		<h3
			*ngIf="currentSessionLimitConverted else noSessionLimitTitle"
			[innerHTML]="'multi-session-limit.current-limit.' + (currentSessionLimitConverted.limitPeriod | lowercase) | translate"
		></h3>
		<span test-id="current-limit-amount" *ngIf="currentSessionLimitConverted else noSessionLimit">
			{{currentSessionLimitConverted.limitValue}} {{"multi-session-limit.current-limit.hours" | translate}}
		</span>
		<ng-template #noSessionLimitTitle>
			<h3>{{"multi-session-limit.current-limit" | translate}}</h3>
		</ng-template>
		<ng-template #noSessionLimit>
			<span>{{ "general.not-set" | translate }}</span>
		</ng-template>
	</div>

	<div class="btn-container" *ngIf="!isSessionLimitEdited">
		<button
			mat-flat-button
			color="accent"
			(click)="editSessionLimit()"
			[disabled]="isSettingBusy"
			test-id="button-change-session-limit"
		>
			<mat-spinner *ngIf="isSettingBusy; else showContent" diameter="20"></mat-spinner>
			<ng-template #showContent>{{ 'multi-session-limit.change-session-limit' | translate }}</ng-template>
		</button>
	</div>
</mat-card>

<mat-card class="obg-m-multi-session-limit-edit" *ngIf="isSessionLimitEdited">
	<form [formGroup]="formGroup" #form="ngForm" (ngSubmit)="submitNewLimit()">
		<h2>{{ 'responsible-gaming.enter-session-time-limits' | translate }}:</h2>

		<mat-radio-group formControlName="sessionLimitPeriod">
			<mat-radio-button
				[value]="SESSION_LIMIT_PERIOD_CONTROLS.Daily"
				[checked]="true"
				color="primary"
				test-id="session-limit-period-daily"
				>{{ 'multi-session-limit.daily' | translate }}</mat-radio-button
			>
			<mat-radio-button
				[value]="SESSION_LIMIT_PERIOD_CONTROLS.Weekly"
				color="primary"
				test-id="session-limit-period-weekly"
				>{{ 'multi-session-limit.weekly' | translate }}</mat-radio-button
			>
			<mat-radio-button
				[value]="SESSION_LIMIT_PERIOD_CONTROLS.Monthly"
				color="primary"
				test-id="session-limit-period-monthly"
				>{{ 'multi-session-limit.monthly' | translate }}</mat-radio-button
			>
		</mat-radio-group>

		<mat-form-field floatLabel="always">
			<mat-label>{{ 'multi-session-limit.label' | translate }}</mat-label>
			<input
				matInput
				type="tel"
				[placeholder]="placeholder"
				formControlName="sessionLimitAmount"
				test-id="input-session-limit-amount"
				obgNumericNotZero
				required
			/>
		</mat-form-field>

		<obg-common-validation-renderer
			[input]="formGroup.controls.sessionLimitAmount"
			translationPrefix="multi-session-limit"
		>
		</obg-common-validation-renderer>

		<div class="btn-container">
			<button
				mat-flat-button
				color="accent"
				type="submit"
				[disabled]="!formGroup.valid"
				test-id="button-set-session-time-limit"
			>
				{{ 'multi-session-limit.set-session-time-limits' | translate }}
			</button>
		</div>
	</form>
</mat-card>
<div class="caption" [innerHtml]="'multi-session-limit.information' | jurisdiction | translate"></div>
